import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, Typography, type InputRef } from 'antd'
import * as qs from 'qs'
import { useEffect, useRef, type FC } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { apiResetPassword } from '~/api/adminApi'
import RadupIcon from '~/assets/images/icon.png'
import { showErrors } from '~/utils/helpers'
import FormCard from './FormCard'
import './styles.scss'

const { Title } = Typography

const ResetPasswordForm = () => {
  const { email, token } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const firstFocusInputRef = useRef<InputRef>(null)

  const resetPasswordMutation = useMutation({
    mutationFn: apiResetPassword,
    onError: showErrors
  })

  useEffect(() => {
    firstFocusInputRef.current?.focus()
  }, [])

  if (resetPasswordMutation.isSuccess) {
    return <div>
      <Title level={2}>Reset Successful</Title>
      <p>Your password has been reset</p>
      <Link style={{ position: 'absolute', bottom: 20 }} to='/signin'>Back to Sign In</Link>
    </div>
  }

  return <Form
    name="normal_login"
    className="login-form"
    onFinish={resetPasswordMutation.mutate}
    initialValues={{
      token,
      email
    }}
  >
    <Title level={2}>Reset Password</Title>
    <Form.Item name='token' hidden><Input hidden /></Form.Item>
    <Form.Item
      name="email"
    >
      <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email" readOnly />
    </Form.Item>
    <Form.Item
      name="password"
      rules={[
        { required: true, message: 'Please input your new password!' }
      ]}
    >
      <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="New Password" type='password' ref={firstFocusInputRef} />
    </Form.Item>
    <Form.Item
      name="password_confirmation"
      rules={[
        { required: true, message: 'Please confirm your new password!' },
        ({ getFieldValue }) => ({
          async validator(_, value) {
            if (value == null || getFieldValue('password') === value) {
              await Promise.resolve(); return
            }
            return await Promise.reject(
              new Error("The password confirmation doesn't match!")
            )
          }
        })
      ]}
    >
      <Input prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Confirm new password" type='password' />
    </Form.Item>

    <Form.Item>
      <Button type="primary" htmlType="submit" className="login-form-button" loading={resetPasswordMutation.isPending}>
        Confirm
      </Button>
    </Form.Item>
  </Form>
}

const ResetPassword: FC = () => {
  return (
    <div className="signin-form">
      <img src={RadupIcon} width="120" alt="" />
      <FormCard>
        <ResetPasswordForm />
      </FormCard>
    </div>
  )
}

export default ResetPassword
